import type { PostHog } from "posthog-js";
import { posthog } from "posthog-js";
import { PostHogProvider, useFeatureFlagEnabled, usePostHog } from "posthog-js/react";
import React, { useCallback } from "react";

import type { FeatureFlagsKeys } from "./types";

export function FeatureFlagProvider({ children }: { children?: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}

export function useFeatureFlag(flag: FeatureFlagsKeys) {
  return useFeatureFlagEnabled(flag) ?? false;
}

export function useFeatureFlagReset() {
  const posthog = usePostHog();

  return useCallback(() => {
    posthog.reset();
  }, [posthog]);
}
